<template>

  <m-a class="button rounded-pill" :href="href"
  ><slot></slot>
  </m-a>

</template>
<script>
export default {
  name: "Bt3",
  props: {
    href: {
      default: "https://mixitweb.com",
    },

    icon: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.button{
  padding: .25rem .75rem;
}
.btn_custom_animated:hover {
  color: #fff !important;
  background-position: right center;
}
.btn_custom_animated_outline {
  border-radius: 50px;
  background-color: transparent;
  border: 1px solid var(--dark) !important;
  color: #0c2e60;
  transition: all 0.4s ease-in-out;
  text-transform: capitalize;
  background-size: 200% auto;
  font-size: 15px !important;
  font-weight: 500;
}
.btn_custom_animated,
.btn_custom_animated_outline:hover {
  box-shadow: 0px 12px 20px 0px rgb(255 126 95 / 15%);
  background-image: linear-gradient(
      to left,
      var(--primary) 0%,
      var(--secondary) 51%,
      var(--primary) 100%
  );
  font-size: 15px !important;
  color: #fff !important;
  transition: all 0.4s ease-in-out !important;
  text-transform: capitalize;
  background-size: 200% auto;
  border: 1px solid transparent !important;
}
.btn_custom_animated_outline:hover {
  color: #fff !important;
  background-position: right center;
}
a{
  text-decoration: none;
}
</style>